import React from 'react';
import { formatPhoneNumber } from '../../helpers';

interface SupportPhoneNumberProps {
  supportPhoneNumber: string | null | undefined;
  leasingOfficeDisplayName?: string; // Customized for VD
}

const SupportPhoneNumber = (props: SupportPhoneNumberProps) => {
  const { supportPhoneNumber } = props;

  if (!supportPhoneNumber) {
    return null;
  }

  const leasingOfficeDisplayName = props.leasingOfficeDisplayName || 'Leasing Office';

  return (
    <span style={{ display: 'block', marginTop: '24px' }}>
      For help, contact the {leasingOfficeDisplayName} at{' '}
      <a href={`tel:${supportPhoneNumber}`} style={{ whiteSpace: 'nowrap' }}>
        <strong>{formatPhoneNumber(supportPhoneNumber)}</strong>
      </a>.
    </span>
  );
};

export default SupportPhoneNumber;
